// src/services/FuelTankService.js
import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

const ROOT = '/business/fuel-tanks'

export default {
  create($, payload) {
    return new Promise((resolve, reject) => {
      HTTP.post(`${ROOT}/`, payload, { headers: { 'Content-Type': 'application/json' } })
        .then(r => resolve(r.data))
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e) })
    })
  },
  update($, id, payload) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`${ROOT}/${id}/`, payload, { headers: { 'Content-Type': 'application/json' } })
        .then(r => resolve(r.data))
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e) })
    })
  },
  remove($, id) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`${ROOT}/${id}/`)
        .then(r => resolve(r.data))
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e) })
    })
  },
  list(params = {}) {
    return new Promise((resolve, reject) => {
      HTTP.get(`${ROOT}/`, { params })
        .then(r => resolve(r.data))
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e) })
    })
  },
  refill($, id, { liters, note }) {
    return new Promise((resolve, reject) => {
      HTTP.post(`${ROOT}/${id}/refill/`, { liters, note }, { headers: { 'Content-Type': 'application/json' } })
        .then(r => resolve(r.data))
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e) })
    })
  },
  adjust($, id, { liters, note }) {               // ← demandé
    return new Promise((resolve, reject) => {
      HTTP.post(`${ROOT}/${id}/adjust/`, { liters, note }, { headers: { 'Content-Type': 'application/json' } })
        .then(r => resolve(r.data))
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e) })
    })
  },
  movements($, id, params = {}) {                 // ← nouveau
    return new Promise((resolve, reject) => {
      HTTP.get(`${ROOT}/${id}/movements`, { params })
        .then(r => resolve(r.data))
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e) })
    })
  },
}
